import { css } from 'linaria';
import tokens from '../../style-configs/tokens';
import { Variables } from '../index';

export const root = css`
    --visible-width: 297px;
    --collapsed-width: 16px;

    flex-shrink: 0;
    height: 100%;
`;

export const hiddenRoot = css`
    height: 100%;
    margin-right: 16px;
    position: relative;
    width: calc(var(--visible-width));

    [data-open='no'] & {
        width: calc(var(--collapsed-width));
    }

    transition-property: width;
    transition-duration: ${tokens.timingDurations.normal};

    @media only screen and (max-width: 1272px) {
        [data-open='yes'] & {
            width: calc(var(--collapsed-width));
        }
    }
`;

export const visibleRoot = css`
    height: 100%;
    width: calc(var(--visible-width));
    position: absolute;
    right: 0;
    transition-property: right;
    transition-duration: ${tokens.timingDurations.normal};

    [data-open='no'] &.hover {
        right: calc(-1 * (var(--visible-width) - var(--collapsed-width)));
    }

    &::before {
        background: ${Variables.css.grey1};
        content: '';
        position: absolute;
        right: 2px;
        top: 0;
        bottom: 0;
        width: 0;
        z-index: 1;
        transition-property: width;
        transition-duration: ${tokens.timingDurations.normal};
    }

    [data-open='no'] &::before {
        width: var(--collapsed-width);
    }

    &.hover::before {
        width: 0;
    }

    @media only screen and (max-width: 1272px) {
        [data-open='yes'] & {
            right: calc(-1 * (var(--visible-width) - var(--collapsed-width)));
        }
    }
`;

export const content = css`
    background: ${Variables.css.grey1};
    color: ${Variables.css.catapultWhite};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding-top: ${Variables.css.spacing40};
    width: var(--visible-width);

    border-right: solid 0 var(--r-catapult-orange);
    transition-property: border-width;
    transition-duration: ${tokens.timingDurations.normal};

    [data-open='no'] & {
        border-width: 2px;
    ]
`;

export const contentDisabled = css`
    background: ${Variables.css.grey1};
    color: ${Variables.css.catapultWhite};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding-top: ${Variables.css.spacing40};
    width: var(--visible-width);
    border-right: solid 0 var(--r-grey-5);
    [data-open='no'] & {
        border-width: 2px;
    ]
`;

export const collapseButton = css`
    background-color: transparent;
    border: solid transparent;
    border-radius: 0 50% 50% 0;
    border-width: 6px 6px 6px calc(var(--collapsed-width) - (${tokens.sizes[24]} / 2));
    color: var(--r-catapult-black);
    cursor: pointer;
    left: calc(var(--visible-width) - var(--collapsed-width));
    top: 0;
    padding: 0;
    position: absolute;
    z-index: 2;
`;
export const collapseButtonInside = css`
    align-items: center;
    background-color: var(--r-catapult-white);
    border: solid 1px var(--r-catapult-black);
    border-radius: 50%;
    display: flex;
    height: ${tokens.sizes[24]};
    justify-content: center;
    width: ${tokens.sizes[24]};
    & > * {
        flex-shrink: 0;
    }

    transition-duration: ${tokens.timingDurations.normal};
    transition-property: transform;
    transform: rotate(0);
    [data-open='no'] & {
        transform: rotate(-180deg);
    }

    &:hover {
        filter: brightness(0.96);
    }
    &:focus,
    &:active {
        filter: brightness(0.92);
    }
`;

export const collapseButtonDisabled = css`
    align-items: center;
    background-color: var(--r-catapult-white);
    border: solid 1px var(--r-grey-5);
    color: var(--r-grey-5);
    border-radius: 50%;
    display: flex;
    height: ${tokens.sizes[24]};
    justify-content: center;
    width: ${tokens.sizes[24]};
    transform: rotate(-180deg);
`;

export const children = css`
    width: var(--visible-width);
`;

export const scrollArea = css`
    overflow: hidden;
    --scrollbar-size: 10px;
`;
export const scrollViewport = css`
    height: 100%;
    width: 100%;
    position: relative;
`;
export const scrollbar = css`
    border-radius: inherit;
    display: flex;
    user-select: none;
    touch-action: none;
    padding: 2px;
    background: rgba(255, 255, 255, 0);
    transition: background 160ms ease-out;
    &:hover {
        background: var(--r-selected-overlay);
    }
    &[data-orientation='vertical'] {
        width: var(--scrollbar-size);
    }
    &[data-orientation='horizontal'] {
        flex-direction: column;
        height: var(--scrollbar-size);
    }
`;
export const scrollbarThumb = css`
    flex: 1;
    background: var(--r-focus-overlay);
    border-radius: var(--scrollbar-size);
    position: relative;
    @media (pointer: coarse) {
        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 100%;
            min-width: 44px;
            min-height: 44px;
        }
    }
`;

export const affixBottom = css`
    border-top: solid 1px var(--r-grey-3);
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    padding-bottom: ${Variables.css.spacing16};
    margin-top: auto;
`;

export const item = css``;

export const itemHasOnClick = css``;

export const itemContent = css`
    overflow: hidden;
    height: 0;
    transition-duration: ${tokens.timingDurations.normal};
    transition-property: height;

    [data-expanded='yes'] > & {
        height: var(--expanded-height);
    }
`;

export const itemLabel = css`
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    height: ${tokens.sizes[48]};
    padding-right: 16px;
    position: relative;
    white-space: nowrap;

    &:hover,
    &:focus-within {
        background-color: var(--r-hover-overlay);
    }

    & button {
        background: transparent;
        border: 0;
        color: inherit;
        cursor: pointer;
    }

    .${item}[data-selected='yes'] > & {
        background-color: var(--r-selected-overlay);
        box-shadow: inset 8px 0px 0px var(--r-catapult-orange);
    }

    // Indenting, measured to *icon* (not button)
    // First level is 48px, every additional level is another 24px
    // We subtract icon-offset to account for the space around the icon inside the button
    // Icon is 16px, button is 40px, so space around the icon (icon-offset) is 12px

    padding-left: 4px;

    --indent-size: 24px;
    --icon-offset: 12px;

    .${itemContent} & {
        padding-left: calc(2 * var(--indent-size) - var(--icon-offset));
    }

    .${itemContent} .${itemContent} & {
        padding-left: calc(3 * var(--indent-size) - var(--icon-offset));
    }

    .${itemContent} .${itemContent} .${itemContent} & {
        padding-left: calc(4 * var(--indent-size) - var(--icon-offset));
    }
`;

export const itemLabelClickArea = css`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    text-decoration: none;
`;

export const itemLabelText = css`
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const itemIcon = css`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    height: ${tokens.sizes[40]};
    justify-content: center;
    padding: 0;
    width: ${tokens.sizes[40]};
`;

export const itemIconAction = css`
    border-radius: 4px;
    height: 28px;
    width: 28px;
`;

export const itemChevron = css`
    height: ${tokens.sizes[16]};
    width: ${tokens.sizes[16]};
    transition-duration: ${tokens.timingDurations.normal};
    transition-property: transform;
    transform: scale(1, 1);
    [data-expanded='yes'] > .${itemLabel} > .${itemIcon}> & {
        transform: scale(1, -1);
    }
`;
